import React from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import { FaExternalLinkAlt, FaGithub, FaInfoCircle } from "react-icons/fa";

const PortfolioCard = ({ portfolio }) => {
  const { imageUrl, name, shortDescription, _id } = portfolio;
  return (
    <div data-aos="zoom-in" className="index portFolioCard ">
      <div className="rounded bg-bgPrimary overflow-hidden shadow-lg pb-4 ">
        {/* image section */}
        <div className="portfolio-img relative">
          <img className="w-full max-h-72" src={imageUrl} alt="Mountain" />
        </div>
        <div className="details">
          <div className="px-6 py-4">
            <div className="font-extrabold text-2xl mb-4">{"By sell app"}</div>
            <p className="text-gray-700 text-base">
              A Collection of free Multicolor CSS, JPG, PNG, SVG Gradients with
              a Gradienta Editor {shortDescription}
            </p>
          </div>
          <div className="flex items-center justify-between gap-4 px-6 pb-4">
            <div className="flex items-center gap-4">
              <a
                href="/as"
                target="_blank"
                className="text-secondaryWhite hover:text-primary transition"
              >
                <FaGithub size={24} />
              </a>
              <a
                href="/as"
                target="_blank"
                className="text-secondaryWhite hover:text-primary transition"
              >
                <FaExternalLinkAlt size={24} />
              </a>
            </div>
            <Link to={`/portfolio/${_id}`} className="border-primary  border px-3 py-1 font-extrabold bg-gradient-to-r from-primary to-[#015871] rounded hover:bg-primary ">Details</Link>
          </div>
          {/* for topics */}
          <div className="px-6 flex items-center gap-3 ">
            <small>React</small>
            <small>Redux</small>
            <small>TypeScript</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
